import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { Col, Container, Row } from 'react-bootstrap'
import { Box, InnerHeading, MainHeading, SpanStyled, TitleHeading } from '../../../ui/Elements'
import { ArrowBtnBrown, ComMap, MBS, ServicesBg, ServicesImg, ServicesImgAr, StatsBg1, StatsBg2, StatsBg3, StatsBg4, StripeBg, StripeBgAr, Vision, VisionAr, VisionBg, VisionBgAr } from '../../../ui/AllImages'

import { useTranslation } from 'react-i18next'
import { AboutBox } from '../../../ui/CustomElements'
import i18n from '../../../Languages/INEXT'
import { ServicesList, StatsList, VisionMissionList } from '../../projectData/Data'
import { Animate } from 'react-simple-animate'
const Stats = () => {
    const { t } = useTranslation();
    const sectionRef = useRef(null);
              const [isVisible, setIsVisible] = useState(false);
        useEffect(() => {
                const observer = new IntersectionObserver(
                  ([entry]) => {
                    // When visible, set to true
                    if (entry.isIntersecting) {
                      setIsVisible(true);
                      observer.disconnect(); // run animation once
                    }
                  },
                  {
                    threshold: 0.2, // 20% of section visible triggers the animation
                  }
                );
            
                if (sectionRef.current) {
                  observer.observe(sectionRef.current);
                }
            
                return () => observer.disconnect();
              }, []);
                const start = { opacity: 0, transform: 'translateY(-40px)' };
                const end = { opacity: 1, transform: 'translateY(0)' };
                const start2 = { opacity: 0, transform: 'translateY(100px)' };
                const end2 = { opacity: 1, transform: 'translateY(0)' };
    
    return (
        <Box id='stats'>
            <StatsWapper className='container-fluid secStats common-space' ref={sectionRef}>
                <Container>
                    <Row className='stats-row'>
                        <Animate
                            play={isVisible}
                            duration={1}
                            delay={.5}
                            start={start}
                            end={end}
                        >
                        <MainHeading className='main-heading main-heading-stats mb-5'>
                            {t('statsHeading')}
                        </MainHeading>
                        </Animate>
                        {StatsList.map((list, key) => (
                            <Col lg={4} sm={12} className='stats-col' key={key}>
                                <Animate
                            play={isVisible}
                            duration={1}
                            delay={1}
                            start={start}
                            end={end}
                        >
                                <Box className="stats-col-inner">
                                    <Box className='statsIconImg'>
                                        {list.img}
                                    </Box>
                                    <Box className='statsContentInner'>
                                        <MainHeading className='main-heading main-heading-stats-number' dir='ltr'>
                                            {t(list.number)}
                                        </MainHeading>
                                        <SpanStyled className='stats-txt' color='var(--secondaryColor)' size="27px">
                                            {t(list.txt)}
                                        </SpanStyled>
                                    </Box>
                                </Box>
                                </Animate>
                            </Col>
                        ))}
                        
                            
                        
                    </Row>
                </Container>
            </StatsWapper>
        </Box>
    )
}
const StatsWapper = styled.section`
    padding-top: 80px;
    padding-bottom: 100px;
    .main-heading-stats{
        text-align: center;
        
        padding-bottom: 15px;
    }
    .main-heading-stats-number{
        text-align: center;
        font-family: var(--iwan) !important;
        font-size: 80px !important;
        line-height: 50px;
        padding-bottom: 7px;
        padding-top: 3px;
    }
    
    .stats-col-inner{
        background-color: var(--bg);
        border-radius: 50px 0 50px 0;
        padding: 28px 15px 20px 15px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 100%;
    }
    .statsIconImg{
        display: flex;
        width: 100%;
        justify-content: center;
    }
    .statsContentInner{
        /* padding-top: 10px; */
    }
    .main-heading-stats{
        text-align: center;
    }
    .stats-txt{
        width: 100%;
        text-align: center;
    }








    .servicesRow{
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
    }


    .secSerrvices{
        overflow: hidden;
    }
    
    .servicesPointsContent{
        display: flex;
        gap: 24px;
    }
    .servicesPointsContentInner{
        display: flex;
        flex-direction: column;
    }
    .servicesPointsContent:first-child{
        margin-bottom: 20px;
    }
    .services-col-ctnt{
        padding-top: 20px;
    }
    .services-col-img{
        display: flex;
        justify-content: end;
        position: relative;
        
        /* background: url(${VisionBg});
        background-repeat: no-repeat;
        background-position: left 0 bottom 0;
        background-size: 750px auto; */
    }
    .services-col-img img{
        z-index: 5;
    }

    
    body.rtl &{
        .stats-col-inner{
            border-radius: 0 50px 0 50px;
        }
        
    }
    @media (max-width: 1199px) {
        
        
        
    }
    @media (max-width: 991px) {
        padding-top: 50px;
        .stats-col{
            margin-bottom: 20px;
        }
        
        .main-heading-stats{
            margin-bottom: 20px !important;
        }
        
    }
    @media (max-width: 767px) {
        
    }
    @media (max-width: 575px) {
        
    }
`
export default Stats
